
import { Component, Vue } from 'vue-property-decorator';
import { IUserProfileUpdate } from '@/interfaces';
import { readUserProfile } from '@/store/main/getters';
import { dispatchUpdateUserPassword } from '@/store/main/actions';

@Component
export default class EditPassword extends Vue {
  public valid = true;
  public old_password = '';
  public password1 = '';
  public password2 = '';
  public ALLOWED_CHARS_REGEX = /^[a-zA-Z0-9!?@№%&$#]+$/;

  public isIncorrectOldPassword = false;
  public loadingSubmit = false;

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public reset() {
    this.old_password = '';
    this.password1 = '';
    this.password2 = '';
    this.$validator.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public created() {
    this.$validator.extend('allowedChars', {
      validate: (value: string) => this.ALLOWED_CHARS_REGEX.test(value),
      getMessage: () => 'Password can only contain: a-z A-Z 0-9 ! ? @ № % & $ #',
    });
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      const updatedProfile: IUserProfileUpdate = {};
      updatedProfile.old_password = this.old_password;
      updatedProfile.password1 = this.password1;
      updatedProfile.password2 = this.password2;
      // {"old_password":["Incorrect password"]}
      try {
        this.loadingSubmit = true;

        const response = await dispatchUpdateUserPassword(this.$store, updatedProfile);
        if(response.data && response.data.old_password){
          this.isIncorrectOldPassword = true
        } else {
           this.$toast.success(this.$t('Password updated').toString())
          this.$router.push('/main/profile');
        }
        // console.log("response", response)
        // this.$router.push('/main/profile');
      } catch (error) {
        console.log("error ", error)
      } finally {
        this.loadingSubmit = false;
      }
      
    }
  }
}
